/**
 * The writers on a Poseidon Live or Chariot Dashboard row (Oct 2026). An
 * order credits every writer with a service on it (chariot-backend
 * utils/serviceWriters.js), so a Chariot row can name several:
 * `service_writers` (their names, the order's own writer first) beside
 * `service_writer` (the same on one line), and on the Collections tab's owed
 * list `writer_ids` as well (the order's own writer, then each with a share).
 * A Shopmonkey row has one writer: `service_writer` / `service_writer_id`.
 */

/** A person's first name ("Joe Smith" → "Joe"); "Unknown" with none. */
export function firstName(fullName) {
  return String(fullName || "").trim().split(/\s+/)[0] || "Unknown";
}

/** A feed row's writers by first name, the order's own first: "Joe", "Joe & Bob", "Joe, Bob & Cal". */
export function writerFirstNames(row) {
  const full = row?.service_writers?.length ? row.service_writers : [row?.service_writer];
  const names = full.filter((name) => String(name || "").trim()).map(firstName);
  if (!names.length) return "Unknown";
  if (names.length === 1) return names[0];
  return `${names.slice(0, -1).join(", ")} & ${names[names.length - 1]}`;
}

/** The writers an owed-list row can be found under, as [id, name] pairs (the writer filter's options). */
export function rowWriterOptions(row) {
  if (row?.writer_ids) return row.writer_ids.map((id, i) => [id, row.service_writers?.[i] || row.service_writer]);
  return row?.service_writer_id ? [[row.service_writer_id, row.service_writer]] : [];
}

/** Is the row one of this writer's: its own writer's, or (a Chariot row) one they have a share in? */
export function rowHasWriter(row, writerId) {
  return (row?.writer_ids || [row?.service_writer_id]).includes(writerId);
}
